module.exports = __webpack_public_path__ + "static/media/appSiteIllustration.a3109c4f.svg";